---
meta:
  - title: Subir documentos a Auri - IUSPRO Docs
  - description: Guía para subir documentos al asistente Auri.
---

# Subir documentos a Auri

Puede subir archivos a Auri para que los analice, resuma, o trabaje con ellos en sus consultas legales.

## ¿Para qué subir documentos?

Los casos más comunes incluyen:

- **Resumir documentos**: Suba un documento largo y pídale a Auri que lo resuma
- **Analizar contenido**: Pida análisis de contratos, resoluciones, o cualquier documento legal
- **Extraer información**: Solicite información específica de documentos extensos
- **Consultas basadas en documentos**: Haga preguntas sobre el contenido del archivo

## Como subir archivos

1. **Ubique el botón de archivos**: A la izquierda del botón azul de enviar
2. **Haga clic para seleccionar archivos**
3. **Suba sus documentos**

## Límites

- Puede subir cuantos archivos quiera
- Cada archivo tiene un límite de **100 MB**

## Ejemplo de uso

### Resumir un documento

1. Suba el archivo
2. Escriba: "Resúmelo"
3. Auri procesará el documento y generará un resumen

### Analizar contenido legal

1. Suba el contrato o documento
2. Pídale a Auri que analice aspectos específicos
3. Puede hacer preguntas de seguimiento sobre el mismo documento

## Trabajar con múltiples archivos

Puede subir varios archivos a la vez y Auri los procesará todos. Puede hacer preguntas que involucren información de todos los documentos subidos.

## Tipos de documentos

Auri puede trabajar con diversos formatos de archivo:

- PDF
- Word (DOC, DOCX)
- Texto plano
- Y otros formatos comunes

## Ventaja del contexto legal

Aunque sube documentos, Auri sigue teniendo acceso a:

- Toda la jurisprudencia de Costa Rica
- Toda la normativa costarricense
- Sus capacidades de búsqueda legal

Esto significa que puede combinar el análisis de sus documentos con referencias legales y jurisprudencia relevante.
